import { dateToMysql } from '@/helpers/dates'

const prepareShow = statistics => {
  statistics.cars = statistics.cars !== '0' ? statistics.cars : 0
  statistics.parkingLoans = statistics.parkingLoans !== '0' ? statistics.parkingLoans : 0
  statistics.schedules = statistics.schedules !== '0' ? statistics.schedules : 0
  statistics.units = statistics.units !== '0' ? statistics.units : 0
  return statistics
}
const prepareSave = profile => {
  profile.country_register = profile.country_register.replace('-', '')
  if (profile.birthdate !== null) {
    profile.birthdate = dateToMysql(profile.birthdate)
  } else {
    delete profile.birthdate
  }

  delete profile.email

  return profile
}

export default {
  doLoad () {
    this.$http.get('/v1/dweller/overview/me')
      .then((data) => {
        this.statistics = prepareShow({...data})
      })
  },
  doSave () {
    const profile = prepareSave({...this.profile})
    this.$resource.update('me', profile)
      .then(({data}) => {
        this.$toast.success('Perfil alterado com sucesso.')
      })
      .catch(({data}) => {
        this.errors = data
      })
  },
  /** ativando ou nao sms notificacoes */
  sendSMS: function (event) {
    if (event.target.checked) {
      this.profile.sms = event.target.checked
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/overview/resources/methods.js